import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Component, createRef } from 'react';
export class DigitInput extends Component {
    constructor(props) {
        super(props);
        this.handleChange = (index, char) => {
            if (!/^\d?$/.test(char))
                return;
            const digits = [...this.state.digits];
            digits[index] = char;
            this.setState({ digits }, () => {
                var _a, _b;
                this.props.onChange(digits.join(''));
                if (char !== '' && index + 1 < this.props.length) {
                    (_b = (_a = this.inputRefs[index + 1]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
                }
            });
        };
        this.handleKeyDown = (event, index) => {
            var _a, _b;
            if (event.key === 'Backspace' && this.state.digits[index] === '' && index > 0) {
                (_b = (_a = this.inputRefs[index - 1]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        };
        this.state = {
            digits: Array.from({ length: props.length }, (_, i) => isValidString(props.value) && props.value.length > i && props.value[i] !== undefined
                ? props.value[i]
                : '')
        };
        this.inputRefs = Array.from({ length: props.length }, () => createRef());
    }
    componentDidMount() {
        var _a, _b;
        if (this.props.autofocus) {
            const firstEmpty = this.state.digits.findIndex((d) => d === '');
            const indexToFocus = firstEmpty === -1 ? this.props.length - 1 : firstEmpty;
            (_b = (_a = this.inputRefs[indexToFocus]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }
    render() {
        const { length, hasError } = this.props;
        const { digits } = this.state;
        return (_jsx("div", { className: `digit-input-container${hasError ? ' error' : ''}`, children: Array.from({ length: length }).map((_, index) => (_jsx("input", { id: index.toString(), type: "text", maxLength: 1, inputMode: "numeric", ref: this.inputRefs[index], value: digits[index], className: 'digit-cell', onChange: (e) => this.handleChange(index, e.target.value), onKeyDown: (e) => this.handleKeyDown(e, index) }, index))) }));
    }
}
DigitInput.defaultProps = {
    length: 6,
    value: '',
    hasError: false,
    autofocus: true
};
